﻿import 'qtip2/dist/basic/jquery.qtip';
import { GetBreakpointWidth } from 'Utils/globals-bp';
import { UpdateSiteHeaderSticky } from 'Modules/headroom.js';
import { ScrollToSearchBarForDropDown } from './groupedSelect-functions.js';

/* jQuery plugin groupedSelect
*/
(function ($) {

    var created_grouped_select = [];

    function useModalDropDown() {
        return GetBreakpointWidth() < 768;
    }

    $.fn.groupedSelect = function (options) {
        var self = this;

        // Methods
        if (typeof options == 'string') {
            var method = options;
            if (method == 'refresh') {
                this.each(function () {
                    var $select = $(this);
                    setCurrentText($select);
                });
            } else if (method == 'updateDropdown') {
                this.each(function () {
                    //var $select = $(this);
                    var $dropdown = $(this).next('.grouped-select');
                    if($dropdown.length > 0) {
                        updateDropdown($dropdown);
                    }
                });
            } else if (method == 'disable' || method == 'enable') {
                let enabled = (method == 'enable') ? true : false;
                this.each(function () {
                    //var $select = $(this);
                    var $dropdown = $(this).next('.grouped-select');
                    if($dropdown.length > 0) {
                        setEnabled($dropdown, null, enabled);
                        updateDropdown($dropdown);
                    }
                });
            } else if (method == 'destroy') {
                this.each(function () {
                    var $select = $(this);
                    var $dropdown = $(this).next('.grouped-select');

                    if ($dropdown.length) {
                        $dropdown.remove();
                        $select.css('display', '');
                    }
                });
                if ($('.grouped-select').length == 0) {
                    $(document).off('.grouped_select');
                }
            } else {
                console.log('Method "' + method + '" does not exist.')
            }
            return this;
        }


        self.settings = $.extend({
            dropdownContainerQtip: null,
            dropdownContainer: null,
            dropdownGroup: null,
            dropdownSelector: null,
            dropdownPositionContainer: false, // position of container in DOM; // Defaults to $(document.body)
            dropdownClasses: false, // add 'dropdown-list-container-qtip' classes
            beforeOpen: function () { return true; },
            afterUpdate: function (sender) { return true; },
            nm: '',
            autoComplete: false,
            placeholder: '',
            dropdownSameWidth: false,
            ignoreTimers: true, // ignore qtip.timers.show if set true
            dropdownModal: true,
            enabled: true
        }, options);
        self.jqDropDownGroup = '.grouped-select';
        if (self.settings.dropdownGroup) {
            self.jqDropDownGroup = self.settings.dropdownGroup;
        }
        self.jqDropDownSelector = '.grouped-select';
        if (self.settings.nm) {
            self.jqDropDownSelector += '.grouped-select-' + self.settings.nm;
        }
        self.settings.dropdownContainerQtip = self.settings.dropdownContainer.substring(1) + '-qtip'
        self.settings.dropdownContainer = self.settings.dropdownContainer + '.' + self.settings.nm;


        self.currentContext = {
            settings: self.settings,
            jqDropDownGroup: self.jqDropDownGroup,
            jqDropDownSelector: self.jqDropDownSelector,
            items: []
        };
        created_grouped_select.push(self.currentContext);

        // Unbind existing events in case that the plugin has been initialized before
        $(document).off('.grouped_select_' + self.settings.nm);

        // Hide native select
        this.hide();

        // Create custom markup
        this.each(function () {
            var $select = $(this);

            if (!$select.next().hasClass('grouped-select')) {
                create_grouped_select($select, self.currentContext);
            }
        });

        function create_grouped_select($select, context) {
            var displayId = $select.attr('id') + '-display';
            $select.after($('<div></div>')
                .addClass('grouped-select')
                .addClass(context.settings.autoComplete ? 'with-autocomplete' : '')
                .addClass($select.attr('class') || '')
                .addClass($select.attr('disabled') ? 'disabled' : '')
                .attr('tabindex', $select.attr('disabled') ? null : '0')
                .html(context.settings.autoComplete ? '<input type="text" id="' + displayId + '" class="current grouped-input" />' : '<span class="current"></span>')
                );

            var $dropdown = $select.next();
            if (context.settings.nm) {
                $dropdown.addClass('grouped-select-' + context.settings.nm);
            }

            // init state of 'enabled' option
            setEnabled($dropdown, context, context.settings.enabled);

            var $options = $select.find('option');
            var $selected = $select.find('option:selected');

            if (context.settings.autoComplete) {
                $dropdown.find('.grouped-input').attr("placeholder", context.settings.placeholder);
            } else {
                $dropdown.find('.current').html($selected.data('display') || $selected.text());
            }

            $(document).on('change.grouped_select_' + context.settings.nm, $select, function (event) {
                setCurrentText($(event.target));
            });

            var $container = $(context.settings.dropdownContainer);
            $(document).on('click.grouped_select_' + context.settings.nm, context.settings.dropdownContainer + ' .optgroup:not(.disabled)', function (event) {
                //2017-11-28 moved to 'data-bind' in template
                //var $optgroup = $(this);
                //$container.find('.optgroup.selected').removeClass('selected');
                //$optgroup.addClass('selected');

                //2017-12-20 same as on '.option' click
                //$select.trigger('change');

                //2018-01-27 disabled "same as on '.option' click"
                //var $option = $(this);
                //var dropdownSelector = getDropdownSelector(context);
                ////$dropdown.focus();
                ////if ($container.data('opened-by-nm') == settings.nm)
                ////    $dropdown.focus();
                //if (event) {
                //    //prevent event if there is bubbling from '.drop-icon'
                //    var $target = $(event.target);
                //    if ($target.hasClass('drop-icon'))
                //        return;
                //}
                //
                //var qtip = $dropdown.qtip('api');
                //if (qtip)
                //    qtip.hide();
                //$('.grouped-select').removeClass('open');
                //setVisibleDropdownSelector(dropdownSelector, false);
            });
            $(document).on('click.grouped_select_' + context.settings.nm, context.settings.dropdownContainer + ' .option:not(.disabled)', function (event) {
                var $option = $(this);
                var dropdownSelector = getDropdownSelector(context);
                //$dropdown.focus();
                //if ($container.data('opened-by-nm') == settings.nm)
                //    $dropdown.focus();
                var qtip = $dropdown.qtip('api');
                if (qtip) {
                    qtip.hide();
                    ScrollToSearchBarForDropDown($dropdown);
                    $('.input-wrapper').removeClass('open');
                }
                $('.grouped-select').removeClass('open');
                setVisibleDropdownSelector(dropdownSelector, false);

            });
            $(document).on('click.grouped_select_' + context.settings.nm, context.settings.dropdownContainer + ' .modal-close' + ', '+ context.settings.dropdownContainer + ' .close', function (event) {
                //var $this = $(this);
                var dropdownSelector = getDropdownSelector(context);
                //$dropdown.focus();
                //if ($container.data('opened-by-nm') == settings.nm)
                //    $dropdown.focus();
                var qtip = $dropdown.qtip('api');
                if (qtip)
                    qtip.hide();
                $('.grouped-select').removeClass('open');
                $('.input-wrapper').removeClass('open');
                setVisibleDropdownSelector(dropdownSelector, false);
            });


            // Open/close sub-items
            $(document).on('click.grouped_select_' + context.settings.nm, context.settings.dropdownContainer + ' .optgroup:not(.disabled) label.drop-icon', function (event) {
                //2018-03-03 moved to 'data-bind' in template
                ////event.stopPropagation();
                ////event.preventDefault();
                //var $label = $(this);
                //var $group = $label.parent('.optgroup');
                ////var $container = $(context.settings.dropdownContainer);
                ////$container.find('.optgroup').not($group).removeClass('open');
                //$group.toggleClass('open');
                //var checkId = '#' + $label.attr('for');
                //var $check = $label.closest('li').find(checkId) || $(checkId);
                ////$check.prop('checked', !$check.prop('checked'));
                //$check.attr('checked', !$check.attr('checked'));
            });

            context.items.push({
                $select: $select,
                $dropdown: $dropdown,
            });

        }

        function setCurrentText($select) {
            var $dropdown = $select.next('.grouped-select');
            var open = $dropdown.hasClass('open');

            if ($dropdown.length) {
                var $selected = $select.find('option:selected');
                var text = "";
                if ($selected.length > 0)
                    text = $selected.data('display') || $selected.text();

                var currentContext = getCurrentContext($dropdown);
                if (currentContext.settings.autoComplete) {
                    //$dropdown.find('.current').val(text);
                } else {
                    $dropdown.find('.current').html(text);
                }

                let afterUpdate = currentContext.settings.afterUpdate;
                if (typeof afterUpdate === 'function') {
                    afterUpdate.apply($select[0], [$dropdown[0]]);
                }
                if ($selected.val()) {
                    $dropdown.find('.current').removeClass('empty');
                } else {
                    $dropdown.find('.current').addClass('empty');
                }
            }
        }

        function setEnabled($dropdown, currentContext, enabled) {
            if (!$dropdown)
                return;

            if(currentContext == null || typeof currentContext == "undefined")
                currentContext = getCurrentContext($dropdown);

            currentContext.settings.enabled = enabled;

            var $input_wrapper = $(currentContext.jqDropDownGroup).parents(".input-wrapper");

            if (currentContext.settings.enabled) {
                $dropdown.removeClass('disabled');
                $input_wrapper.removeClass('disabled');
            } else {
                $dropdown.addClass('disabled');
                $input_wrapper.addClass('disabled');
            }
        }


        function updateDropdown($dropdown, currentContext) {
            if (!$dropdown)
                return;

            if(typeof currentContext == "undefined")
                currentContext = getCurrentContext($dropdown);

            let qtip = $dropdown.qtip('api');
            if (qtip && qtip.isShowing) {
                var $dropdownContainerQtip = $("." + currentContext.settings.dropdownContainerQtip);
                var isModalMode = $dropdownContainerQtip.hasClass("modal");
                var useModalMode = currentContext.settings.dropdownModal? useModalDropDown() : false;

                if (useModalMode != isModalMode) {
                    updateQtipModalMode(useModalMode, qtip, $dropdownContainerQtip);
                }

                var $container = $(currentContext.settings.dropdownContainer);
                fixModalHeadHeight($container);
                fixQtipAdjust($dropdown);
                fixAutocompleteInside($dropdown, $dropdownContainerQtip);
            }
        }

        function getDropdownSelector(context) {
            var dropdownSelector = null;
            if (typeof context.settings.dropdownSelector != "undefined" && context.settings.dropdownSelector != null) {
                if (typeof context.settings.dropdownSelector == "function") {
                    dropdownSelector = context.settings.dropdownSelector();
                } else {
                    dropdownSelector = context.settings.dropdownSelector;
                }
            }
            return dropdownSelector;
        }

        function setVisibleDropdownSelector(dropdownSelector, visible) {
            if (!dropdownSelector)
                return;
            if (typeof dropdownSelector.Visible == "undefined")
                return;

            if (typeof dropdownSelector.Visible == "function") {
                dropdownSelector.Visible(visible);
            } else {
                dropdownSelector.Visible = visible;
            }
        }

        function handleOnShowDropdownSelector(dropdownSelector) {
            if (!dropdownSelector)
                return;
            if (typeof dropdownSelector.OnShow == "undefined")
                return;

            if (typeof dropdownSelector.OnShow == "function") {
                dropdownSelector.OnShow();
            }
        }

        function getCurrentContext($dropdown) {
            var g = $.grep(created_grouped_select, function (item) {
                var found = false;

                var sub_g = $.grep(item.items, function (sub_item) { return sub_item.$dropdown.is($dropdown); });
                found = sub_g.length > 0;

                return found;
            });
            if (g.length > 0) {
                return g[0];
            } else {
                console.log("Not found by $dropdown: " + $dropdown);
                return null;
            }
        }

        function fixModalHeadHeight($container) {
            var $contentHead = $container.find('.modal-head');
            var $stickyWrapper = $contentHead.parent('.sticky-wrapper');
            if ($stickyWrapper.length == 0) {
                var wrapper = $('<div></div>')
                    .addClass('sticky-wrapper');
          
                    $contentHead.wrapAll(function() {
                            return wrapper;
                    })
                    $stickyWrapper = $contentHead.parent('.sticky-wrapper');
            }
            $stickyWrapper.css('height', $contentHead.outerHeight(true));
        }

        function fixQtipAdjust($dropdown, $dropdownContainerQtip) {
            var currentContext = getCurrentContext($dropdown);
            if (!$dropdownContainerQtip) {
                $dropdownContainerQtip = $("." + currentContext.settings.dropdownContainerQtip);
            }
            var api = $dropdown.qtip('api');
            var isModalMode = $dropdownContainerQtip.hasClass("modal");
            if (isModalMode) {
                api.set('position.adjust.x', 0);
                $dropdownContainerQtip.css({ "width": '' });
                $dropdownContainerQtip.css({ "maxWidth": '' });
            } else {
                var $form = $dropdown.parents(".search .searchbar-body");
                if ($form.length > 0) {
                    var leftForm = $form.offset().left;
                    var leftTarget = $dropdown.offset().left;
                    var currLeft = leftForm - leftTarget;
                    var newWidth = $form.outerWidth()// without margin (on HW form is centered by margin)
                    api.set('position.adjust.x', currLeft);
                    $dropdownContainerQtip.css({ "width": newWidth });
                    $dropdownContainerQtip.css({ "maxWidth": newWidth });
                } 

                if (currentContext.settings.dropdownSameWidth) {
                    var newWidth = $dropdown.outerWidth();
                    api.set('position.adjust.x', 0);
                    $dropdownContainerQtip.css({ "width": newWidth });
                    $dropdownContainerQtip.css({ "maxWidth": newWidth });
                }
            }

        }

        function fixAutocompleteInside($dropdown, $dropdownContainerQtip) {
            if (!$dropdownContainerQtip) {
                var currentContext = getCurrentContext($dropdown);
                $dropdownContainerQtip = $("." + currentContext.settings.dropdownContainerQtip);
            }
            var api = $dropdown.qtip('api');
            if ($dropdownContainerQtip.length > 1 && api.tooltip && api.tooltip.length > 0) {
                // FIXME !!! refacoring :: found bug :: make it in better way
                $dropdownContainerQtip = api.tooltip;
            }
            var isModalMode = $dropdownContainerQtip.hasClass("modal");
            var qtipContainerId = "#"+$dropdownContainerQtip.attr('id');
            if ($dropdownContainerQtip.length > 1) {
                // FIXME !!! refacoring :: found bug :: make it in better way
                qtipContainerId = "#"+ (api.tooltip.attr("id") || api._id);
            }

            var $autocomplete = $dropdownContainerQtip.find('.ui-autocomplete-input');
            $autocomplete.each(function (i, elem) {
                var $elem = $(elem);
                var $widget = $elem.autocomplete("widget");
                if ($elem.autocomplete("option", "appendTo") != qtipContainerId)
                    $elem.autocomplete("option", "appendTo", qtipContainerId);
                //$elem.autocomplete("option", "appendTo", $dropdownContainerQtip);
                if (isModalMode) {
                    $elem.addClass("modal");
                    $widget.addClass("modal");
                    $elem.autocomplete("option", "position", { my : "center top", at: "center bottom", collision: "fit none" });
                } else {
                    $elem.removeClass("modal");
                    $widget.removeClass("modal");
                    $elem.autocomplete("option", "position", { my : "left top", at: "left bottom", collision: "fit none" });

                    setTimeout(function () {
                        elem.focus();
                    }, 300);
                }
                if ($dropdownContainerQtip.hasClass('is-sticky-parent')) {
                    $elem.addClass('is-sticky-parent');
                    $widget.addClass('is-sticky-parent');
                }
            });
        }

        function fixQtipScrollTop(api, callback) {
            let cb_fixQtipScrollTop = (callback && typeof callback == "function") ? callback : function () { };

            if (!api) {
                cb_fixQtipScrollTop();
                return;
            }

            var holder = api.target;
            var windowHeight = $(window).height();
            var offset = windowHeight / 2;

            if (holder.outerHeight() >= offset) {
                // no sence to scroll
                cb_fixQtipScrollTop();
                return;
            }

            var currentTop = $(window).scrollTop();
            var minTop = currentTop + offset;
            var holderTop = holder.offset().top;

            if (minTop > holderTop) {
                // don't scroll if holder is located near top of screen
                cb_fixQtipScrollTop();
                return;
            }

            // height of dropdown's inner-view: 70vh;
            // padding-bottom of dropdown: 16px;
            //var maxHeightOfDropdown = api.tooltip.outerHeight();
            var maxHeightOfDropdown = windowHeight * 0.7 + 16;
            
            // space between control and dropdown: ~29-30px
            var marginTop = api.tooltip ? parseInt(api.tooltip.css("margin-top")) : 0;
            //var marginTop = 30;

            // chat's space at window's bottom: 40px (height 30px + 10px bottom)
            var maxHeight = holder.outerHeight() + marginTop + maxHeightOfDropdown + 40;
            var maxOffset = windowHeight - maxHeight;

            var halfOffset = offset / 2;
            if (halfOffset > maxOffset) {
                offset = maxOffset;
            } else {
                offset = halfOffset;
            }

            $('html, body').stop().animate({
                scrollTop: holder.offset().top - offset
            }, 300, cb_fixQtipScrollTop);
        }

        function updateQtipModalMode(useModalMode, api, $dropdownContainerQtip) {
            if (useModalMode) {
                $dropdownContainerQtip.addClass("modal");
                $('html').addClass("noscroll");
                api.set('hide.event', 'click');
            } else {
                //$(document.body).removeClass("noscroll");
                $('html').removeClass("noscroll");
                $dropdownContainerQtip.removeClass("modal");
                api.set('hide.event', 'unfocus');                
            }

        }

        function bindQtip($dropdown) {
            var currentContext = getCurrentContext($dropdown);

            // qtip classes with '.faded'
            var classes = currentContext.settings.dropdownContainerQtip;
            var $header = $dropdown.parents('.header');
            if ($header.length > 0) {
                if (!$header.hasClass('searchpage')) {
                    classes += " faded";
                }
            }
            classes += " vh-max-height";
            if ($dropdown.hasClass('is-sticky-parent')) {
                classes += " is-sticky-parent";
            }

            if (currentContext.settings.dropdownClasses) {
                switch (typeof currentContext.settings.dropdownClasses) {
                    case "boolean":
                        classes = "dropdown-list-container-qtip " + classes;
                        break;
                    case "string":
                        classes = currentContext.settings.dropdownClasses + " " + classes;
                        break;

                    default:
                        break;
                }
            }

            var $parent = $dropdown.parents('.input-wrapper');
            var posMy = 'top center';
            var posAt = 'bottom center';
            var pLeft = 0;
            var $addon = $parent.find('.addon');
            if ($addon.length > 0) {
                posMy = 'top left';
                posAt = 'bottom left';
                pLeft = $addon.outerWidth(true) * -1;
            }
            var $container = $(currentContext.settings.dropdownContainer);

           // $container.find('.modal-head').sticky({ topSpacing: 0, zIndex: 5, widthFromWrapper: false });
            fixModalHeadHeight($container);

            $(window).resize(function () {
                updateDropdown($dropdown, currentContext);
                /*
                let qtip = $dropdown.qtip('api');
                if (qtip && qtip.isShowing) {
                    var $dropdownContainerQtip = $("." + currentContext.settings.dropdownContainerQtip);
                    var isModalMode = $dropdownContainerQtip.hasClass("modal");
                    var useModalMode = useModalDropDown();

                    if (useModalMode != isModalMode) {
                        updateQtipModalMode(useModalMode, qtip, $dropdownContainerQtip);
                    }
                
                    fixModalHeadHeight();
                    fixQtipAdjust($dropdown);
                }
                */
            });

            // details: http://qtip2.com/options#position.container and http://qtip2.com/options#global
            let positionContainer = false;
            if (currentContext.settings.dropdownPositionContainer) {
                let dpc = currentContext.settings.dropdownPositionContainer;
                if (typeof dpc == "string") {
                    if ("PARENT_CONTAINER".toLowerCase() == dpc.toLowerCase()) {
                        positionContainer = $container.parent();
                    } else if (dpc.startsWith('.') || dpc.startsWith('#')) {
                        // selector
                        positionContainer = $(dpc);
                    } else {
                        // ???
                        positionContainer = dpc;
                    }
                } else {
                    positionContainer = dpc;
                }
            }

            $dropdown.qtip({
                show: {
                    event: '', // 'click' - disabled auto-event because method show() is used
                    ready: true,
                    solo: true,
                },
                overwrite: 'false',
                hide: 'unfocus',
                // 2018-05-17 Changed because qtip.hideMethod is executed before 'click.grouped_select' event rises
                //hide: {
                //    event: 'click',
                //    delay: 700,
                //    //fixed: true,
                //    //leave: false
                //},
                content: {
                    text: $container
                },
                position: {
                    target: $dropdown,
                    container: positionContainer,
                    my: posMy,
                    at: posAt,
                    tooltip: 'topMiddle',
                    //viewport: $(window),
                    //viewport:true,
                    adjust: {
                        x: pLeft,
                        y: 0
                    },
                    //effect: false //no-animation
                    effect: function (api, pos) {
                        //The default animation callback
                        //$(this).animate(pos, { duration: 200, queue: FALSE });

                        //fix animation when searchbar becomes sticky => no-sticky
                        if (api.elements.target.hasClass('is-sticky-parent')) {
                            var window_top = $(window).scrollTop();
                            pos.top = window_top + 51;
                        }
                        $(this).animate(pos, {
                            duration: 0,
                            queue: false,
                            complete: function () {
                                //fix autocomplete list when searchbar becomes sticky => no-sticky
                                //api.elements.tooltip
                                var $autocomplete = api.tooltip.find('.ui-autocomplete-input')
                                $autocomplete.each(function (i, elem) {
                                    var $elem = $(elem);
                                    var $widget = $elem.autocomplete("widget");
                                    //if (!$widget.hasClass('is-sticky-parent')) {
                                    if ($widget.is(":visible")) {
                                        $elem.autocomplete("search");
                                    }
                                });
                            }
                        });
                    }
                },
                style: {
                    //classes: currentContext.settings.dropdownContainer.substring(1) + '-qtip',
                    //classes: currentContext.settings.dropdownContainerQtip,
                    classes: classes, // + " vh-max-height is-sticky-parent",
                    def: false,
                },
                events: {
                    hide: function (event, api) {
                        UpdateSiteHeaderSticky();
                        $(currentContext.jqDropDownGroup).removeClass('open');
                        var $input_wrapper = $(currentContext.jqDropDownGroup).parents(".input-wrapper");
                        $input_wrapper.removeClass('open');
                        $('html').removeClass("noscroll");

                        var scrollTop = $dropdown.attr("data-last-top") || null;
                        if (scrollTop != null && $.isNumeric(scrollTop) && scrollTop >= 0) {
                            $('html, body').stop().delay(10).animate({
                                scrollTop: parseInt(scrollTop)
                            }, 0);
                        }
                        var dropdownSelector = getDropdownSelector(currentContext);
                        setVisibleDropdownSelector(dropdownSelector, false);
                        //scrollToSearchBar($dropdown);
                        if (api) api.isShowing = false;
                    },
                    render: function (event, api) {
                        //var $dropdownContainerQtip = $("." + currentContext.settings.dropdownContainerQtip);
                        //$dropdownContainerQtip.find('.modal-head').sticky({ topSpacing: 0, zIndex: 5, widthFromWrapper: false });
                        //function fixModalHeadHeight() {
                        //    var $contentHotelNav = $dropdownContainerQtip.find('.modal-head');
                        //    $contentHotelNav.parent('.sticky-wrapper').css('height', $contentHotelNav.outerHeight(true));
                        //};
                        //fixModalHeadHeight();
                        //$(window).resize(fixModalHeadHeight);
                    },
                    show: function (event, api) {
                        //event.preventDefault(); // Stop it!
                        if (api) api.isShowing = true;
                        var $dropdownContainerQtip = $("." + currentContext.settings.dropdownContainerQtip);
                        var useModalMode = currentContext.settings.dropdownModal ? useModalDropDown() : false;
                        updateQtipModalMode(useModalMode, api, $dropdownContainerQtip);

                        if (useModalMode) {
                            if (global.siteHeadRoom != null) {
                                global.siteHeadRoom.destroy();
                            }
                            //$dropdownContainerQtip.find('.modal-head').sticky({ topSpacing: 0, zIndex: 5, widthFromWrapper: false });
                            setTimeout(function () {
                                fixModalHeadHeight($container);
                            }, 100);

                            /* On some mobile browser when the overlay was previously
                            opened and scrolled, if you open it again it doesn't 
                            reset its scrollTop property */
                            //$dropdownContainerQtip.scrollTop = 0;
                        } else {
                            fixQtipScrollTop(api);
                        }

                        fixQtipAdjust($dropdown, $dropdownContainerQtip);
                        fixAutocompleteInside($dropdown, $dropdownContainerQtip);
                    }
                }
            });
            return $dropdown.qtip('api');
        }
        /* Event listeners */

        // Open/close
        $(document).on('click.grouped_select_' + self.settings.nm, self.jqDropDownSelector, function (event) {
            var $dropdown = $(this);
            var $input_wrapper = $dropdown.parents(".input-wrapper");
            var currentContext = getCurrentContext($dropdown);

            $('.grouped-select').not($dropdown).removeClass('open');
            $(".input-wrapper").removeClass('open');

            if (currentContext.settings.enabled) {
                $dropdown.toggleClass('open');
            } else {
                $dropdown.removeClass('open');
            }
            var $container = $(currentContext.settings.dropdownContainer);

            var dropdownSelector = getDropdownSelector(currentContext);

            var qtip = $dropdown.qtip('api');
            if (!qtip) {
                qtip = bindQtip($dropdown);
            }

            if ($dropdown.hasClass('open')) {
                $input_wrapper.addClass('open');
                currentContext.settings.beforeOpen();
                setVisibleDropdownSelector(dropdownSelector, true);
                handleOnShowDropdownSelector(dropdownSelector);
                $container.data('opened-by-nm', currentContext.settings.nm);
                if (qtip) {
                    var $dropdownContainerQtip = $("." + currentContext.settings.dropdownContainerQtip);
                    var useModal = currentContext.settings.dropdownModal ? useModalDropDown() : false;
                    var top = useModal ? ($(window).scrollTop() || $('html, body').scrollTop()) : '';
                    $dropdown.attr("data-last-top", top);
                    var delay = 0;
                    let ignoreTimers = currentContext.settings.ignoreTimers;
                    if (!ignoreTimers && qtip.timers && qtip.timers.show && qtip.timers.show > 0) {
                        delay = parseInt(qtip.timers.show) + 50;
                    }
                    // 'long-time-openning dropdowns' keep next lines alive for testing
                    //if (qtip.timers && qtip.timers.show && qtip.timers.show > 0) {
                    //    console.log('>>>>>> qtip.timers.show = ' + qtip.timers.show);
                    //} else {
                    //    console.log('>>>>>> qtip.timers.show is null.');
                    //}

                    if (delay > 0) {
                        setTimeout(function () {
                            fixQtipScrollTop(qtip, function () {
                                // Animation complete.
                                qtip.show();
                            });
                        }, delay);
                    } else {
                        fixQtipScrollTop(qtip, function () {
                            // Animation complete.
                            qtip.show();
                        });
                    }
                }
                $dropdown.find('.option');
                $dropdown.find('.focus').removeClass('focus');
                $dropdown.find('.selected').addClass('focus');
                //$(currentContext.jqDropDownGroup).not($dropdown).addClass('open');
            } else {
                $dropdown.focus();
                if (qtip)
                    qtip.hide();
                $container.data('opened-by-nm', '');
                setVisibleDropdownSelector(dropdownSelector, false);
                $input_wrapper.removeClass('open');
                //$(currentContext.jqDropDownGroup).not($dropdown).removeClass('open');
            }

            var $input = $dropdown.find('.grouped-input');
            // close if already visible
            if ($input.length > 0 && $input.autocomplete("widget").is(":visible")) {
                $input.autocomplete('close');
            }
        });

        if (self.settings.autoComplete) {
            // On document doesn't work because qtip.events.show rises also
            //$(document).on('click.grouped_select_' + self.settings.nm, self.jqDropDownSelector + ' .grouped-input', function (event) {
            $(self.jqDropDownSelector + ' .grouped-input').on('click.grouped_select_' + self.settings.nm, function (event) {
                var $input = $(this);
                event.stopPropagation();
                event.preventDefault();
                $dropdown = $input.parent('.grouped-select');
                if ($dropdown.length > 0) {
                    var qtip = $dropdown.qtip('api');
                    if (qtip)
                        qtip.hide();
                    $dropdown.removeClass('open');
                    $input_wrapper.removeClass('open');
                }
            });
        }

        return this;
    };

}(jQuery));